import * as _ from 'lodash';
import { useEffect, useState } from 'react';

import { AccountLoginStateResponse } from '../../../../typings/api';
import { get } from '../../../redux/api';

type LoginMethods = {
  bitbucket?: boolean;
  github?: boolean;
  gitlab?: boolean;
  google?: boolean;
};

/**
 * Makes a request to /account/login_state once on mount, then manages the
 * state of the active OAuth login method options.
 * The LoginMethods are updated once after the request to /login/next,
 * which is why we export a method to update them.
 *
 * @param {boolean} skip - Whether to skip the entire fetch request and return false for all login methods.
 */
export default function useGetLoginMethods(
  skip: boolean,
): [LoginMethods, (updatedLoginMethods: Partial<LoginMethods>) => void] {
  const [loginMethods, setLoginMethods] = useState<LoginMethods>({
    bitbucket: false,
    github: false,
    gitlab: false,
    google: false,
  });

  const onUpdateLoginMethods = (updatedMethods: Partial<LoginMethods>) => setLoginMethods((loginMethods: LoginMethods) => ({
    ...loginMethods,
    ...updatedMethods,
  }));

  //  Fetch the login methods once, on mount.
  useEffect(() => {
    const fetchLoginMethods = async () => {
      const { data } = await get<AccountLoginStateResponse>('/account/login_state');
      //  Remove 'subdomain' as that is handled by the parent.
      if (data?.loginMethods) {
        onUpdateLoginMethods(_.omit(data.loginMethods, 'subdomain'));
      }
    };

    if (!skip) {
      fetchLoginMethods();
    }
  }, []);

  return [
    loginMethods,
    onUpdateLoginMethods,
  ];
};
